import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ClInputDate } from '@corelabs/angular/ui';
import { ErrorComponent } from '../error/error.component';

@Component({
    selector: 'app-form-input-date',
    templateUrl: './form-input-date.component.html',
    styleUrls: ['./form-input-date.component.css'],
    imports: [ReactiveFormsModule, ClInputDate, ErrorComponent],
})
export class FormInputDateComponent {
    readonly control = input.required<FormControl<Date | null>>();
    readonly label = input.required<string>();
    readonly inputId = input.required<string>();
    readonly min = input<Date>();
    readonly max = input<Date>();
}
